import { apiHelper, sessionHelper, sharedHelper } from '@/utils'
import { API } from '@/constants'

export const vehicleService = {
    getAllVehicles,
    updateVehicleStatus,
    getVehicle,
    updateVehicle,
    createVehicle,
    getVehicleByCarPlate,
    linkVehicleByCustomerID,
    linkVehicleByEmail
};

const MODULE = {
    VEHICLE: 'customer-vehicles',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'user') + '/v1'
const API_URL = API.BASE_URL + '/v1'

let userType = sessionHelper.getUserType();

export function getAllVehicles(filter) {

    const requestOptions = {
        params: {
            page: filter.pageNumber,
            size: filter.pageSize,
            is_locked: filter.isLocked,
            is_active: filter.isActive
        }
    }

    let array = filter.searchArray
    array.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`
            requestOptions.params[searchParam] = word
        }
    })

    return apiHelper(API_URL).get(`/${MODULE.VEHICLE}`, requestOptions)
}


export function updateVehicleStatus(data) {
    const requestOptions = {
        is_active: data.isActive
    }

    return apiHelper(API_URL).patch(`/${MODULE.VEHICLE}/${data.id}/update`, requestOptions)
}

export function getVehicle(id) {
    return apiHelper(API_URL).get(`/${MODULE.VEHICLE}/${id}`)
}

export function updateVehicle(data) {
    const requestOptions = {
        model_uuid: data.modelID,
        is_new_car: data.isNewCar,
        next_reminder_date: data.nextReminderDate,
        year_made: data.yearMade,
        year_bought: data.yearBought,
        car_vehicle_identification_number: data.carVIN,
        description: data.description,
        engine_number: data.engineNumber,
        transmission: data.transmission,
        engine_size: data.engineSize,
        car_plate_number: data.carPlateNumber,
        vehicle_uuid: data.vehicleID
    }

    return apiHelper(API_URL).put(`/${MODULE.VEHICLE}/${data.id}`, requestOptions)
}

export function getVehicleByCarPlate(data) {
    const requestOptions = {
        car_plate_number: data.carPlateNumber,
        car_plate_type: data.carPlateType,
    }

    return apiHelper(API_URL).post(`/${MODULE.VEHICLE}/verify/plate-number`, requestOptions)
}

export function createVehicle(data) {
    const requestOptions = {
        car_plate_number: data.carPlateNumber,
        model_uuid: data.modelID.value,
        year_made: data.yearMade,
        car_vehicle_identification_number: data.carVIN,
    }

    return apiHelper(API_URL).post(`/${MODULE.VEHICLE}`, requestOptions)
}

export function linkVehicleByCustomerID(data) {
    const requestOptions = {
        customer_uuid: data.customerID,
        vehicle_uuid: data.vehicleID,
    }

    return apiHelper(API_URL).patch(`/${MODULE.VEHICLE}/link`, requestOptions)
}

export function linkVehicleByEmail(data) {
    if (userType == "ADMIN") {
        const requestOptions = {
            customer_email: data.customerEmail,
            vehicle_uuid: data.vehicleID,
        }

        return apiHelper(API_URL).patch(`/${MODULE.VEHICLE}/link/email`, requestOptions)
    }
    else {
        sharedHelper.alertErrorMessage("Invalid Permission", "0000")
    }
}